module.exports = __webpack_public_path__ + "img/4.9528ad2a.png";